import { render } from "./CreateAutreOrganisation.vue?vue&type=template&id=23a86050"
import script from "./CreateAutreOrganisation.vue?vue&type=script&lang=js"
export * from "./CreateAutreOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__